module.exports = __webpack_public_path__ + "img/info.16e6f0e3.svg";